export default __webpack_public_path__ + "static/media/elective-icon.311108a7.svg";